import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class ToolbarTriggerService {
    public message = new BehaviorSubject<any>('DEFAULT_MESSAGE');

    changeToolbarDetailData(value: any) {
        this.message.next(value); //it is publishing this value to all the subscribers that have already subscribed to this message
    }
}
